import { render } from "./License.vue?vue&type=template&id=41e9481c&scoped=true"
const script = {}

import "./License.vue?vue&type=style&index=0&id=41e9481c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\EDZ\\Desktop\\emulator\\linux_app_emulator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e9481c"]])

export default __exports__